import React from "react";
import logo_mea from "../resource/mea_ev_icon.svg";

const Logo = () => {
  return (
    <div className=' w-36 mt-5 flex flex-col items-center'>
      <img src={logo_mea} alt='logo' className='w-36 h-36 ' />
    </div>
  );
};

export default Logo;
